import React from 'react';
import { useTranslation } from 'react-i18next';
import '../Tool/Tool.css'; 

function Whatisit() {
  const { t } = useTranslation();

  return (
   <div className="cases-page">
  <div className="text-container-cases">
    <h2 className="title-blue-cases">{t('whatis-text-title')}</h2>
    <p className="actions-header">{t('whatis-text-1')}</p>
    <p className="actions-header">{t('whatis-text-2')}</p>
    <p className="actions-header">{t('whatis-text-3')}</p>
      <ul className="cases-list">
        <li>{t('whatis-text-opt1')}</li>
        <li>{t('whatis-text-opt2')}</li>
        <li>{t('whatis-text-opt3')}</li>
        <li>{t('whatis-text-opt4')}</li>
      </ul>
      <p className="actions-header">{t('whatis-text-4')}</p>
      <p className="actions-header">{t('whatis-text-5')}</p>
    </div>
  </div>

  );
}

export default Whatisit;